module.exports = wp.element;


//////////////////
// WEBPACK FOOTER
// external "wp.element"
// module id = 2
// module chunks = 0